import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({name: 'widgetIcon'})

export class WidgetIconPipe implements PipeTransform {

	constructor(private translate: TranslateService) {

	}

	transform(widgetType: string, inApp: boolean, appLabel?: string): string {
		if ( !widgetType ) {
			return '';
		}

		let icon;
		let ret;

		switch (widgetType) {
			case 'app':
				icon = 'object-group';
				break;
			case 'formTextArea':
				icon = 'pen-to-square';
				break;
			case 'formTextField':
				icon = 'square-pen';
				break;
			case 'formSelect':
				icon = 'square-caret-down';
				break;
			case 'variableString':
				icon = 'font';
				break;
			case 'textLabel':
				icon = 'font';
				break;
			case 'image':
				icon = 'image';
				break;
			case 'video':
				icon = 'film';
				break;
			case 'audio':
				icon = 'headphones';
				break;
			case 'rectangle':
				icon = 'square-o';
				break;
			case 'timer':
				icon = 'clock-o';
				break;
			case 'comment':
				icon = 'info-circle';
				break;
			case 'custom':
				icon = 'code';
				break;
			case 'chapter':
				icon = 'paragraph';
				break;
			case 'action_only':
				icon = 'circle-o-notch';
				break;
			case 'document':
				icon = 'file-o';
				break;
			case 'font':
				icon = 'font';
				break;
			case 'button':
				icon = 'hand-pointer';
				break;
			default:
				icon = 'cog';
		}
		if (inApp) {
			ret = '<i class="fa fa-folder-open" title="In template' + (appLabel ? (': ' + appLabel) : '') +
					'"></i><i title="' + this.translate.instant('WIDGET_TYPE_' + widgetType.toUpperCase()) + '" class="fa fa-' + icon + '"></i>';
		} else {
			ret = '<i title="' + this.translate.instant('WIDGET_TYPE_' + widgetType.toUpperCase()) + '" class="fa fa-' + icon + '"></i>';
		}

		return ret;
	}
}
